// Stripe redirects here (success_url / cancel_url) on native, where it loads inside
// the in-app browser. The in-app browser can't close itself, so the user closes it
// to return to the app — openPaymentCheckout listens for that. On web the checkout
// opens in the same tab and returns to the originating page, not here.
export default function PaymentReturn() {
  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        padding: 24,
        textAlign: 'center',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#16a34a',
          color: '#fff',
          fontSize: 28,
        }}
      >
        ✓
      </div>
      <h1 style={{ fontSize: 20, margin: 0 }}>Payment Complete</h1>
      <p style={{ color: '#fff', margin: 0 }}>You can close this window and return to the app.</p>
    </div>
  );
}
